import React from 'react';
import { ButtonTheme, SelectionType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, bool, color, element, eventListener, number, object, oneOf, oneOfType, record, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ClickEvent, SelectEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { classNames, enumValues, getLostProps, isFunction, isValidWidth, propagateProps } from '@philips-internal/oswald-ui-utils';
import { useIsXSmallResolution } from '../../../hooks/use-is-xsmall-resolution.js';
import { Swipe } from '../../swipe/swipe.js';
import { CardContainerProvider } from '../context/card-container-context.js';
import { CardContainerAPI } from './card-container-api.js';
import './card-container.css';
const CardContainerContainer = {
    name: '',
};
function CardContainer(props) {
    const isXSmallResolution = useIsXSmallResolution();
    const lostProps = getLostProps(CardContainer.propTypes, props);
    const onSelectEvent = (selected) => {
        if (props.disabled || !isFunction(props.onSelect)) {
            return;
        }
        const event = new SelectEvent({ selected, value: props.uuid });
        props.onSelect(event);
    };
    const onSelectionInputChange = (event) => {
        onSelectEvent(event.value);
    };
    const onClick = () => {
        if (props.disabled) {
            return;
        }
        if (props.selectable && props.selectionType !== SelectionType.NONE) {
            return onSelectEvent(!props.selected);
        }
        if (isFunction(props.onClick)) {
            props.onClick(new ClickEvent());
        }
    };
    const className = classNames({
        'c-card-container': true,
        'c-card-container--disabled': Boolean(props.disabled),
        'c-card-container--selectable': Boolean(props.selectable),
        'c-card-container--selected': Boolean(props.selected),
        [`u-grid-col-${props.width}`]: isValidWidth(props.width),
        [`${props.className}`]: Boolean(props.className),
    });
    const propagatedProps = {
        ...lostProps,
        data: props.data,
        onSelectionInputChange,
        selectable: props.selectable,
        selected: props.selected,
        selectionType: props.selectionType,
        swipeActions: props.swipeActions,
    };
    let content = (React.createElement("div", { className: className, onClick: onClick, role: props.role },
        React.createElement(Container, { className: "c-card-container__content", uuid: props.uuid }, propagateProps(props.children, propagatedProps))));
    const hasSwipeActions = props.swipeActions && props.swipeActions.length > 0;
    if (isXSmallResolution && hasSwipeActions) {
        content = (React.createElement(Swipe, { actions: props.swipeActions, className: className }, content));
    }
    return (React.createElement(CardContainerProvider, { superscription: { entry: props.superscriptionEntry, items: props.superscription } }, content));
}
CardContainer.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    className: string,
    data: object,
    disabled: bool,
    onClick: eventListener,
    onContextMenuClick: eventListener,
    onDoubleClick: eventListener,
    onSelect: eventListener,
    role: string.notEnumerable(),
    selectable: bool.notEnumerable(),
    selected: bool.notEnumerable(),
    selectionType: oneOf(enumValues(SelectionType)).notEnumerable(),
    superscription: record({ color: color, icon: oneOfType([string, element]), label: string, value: string }),
    superscriptionEntry: string,
    swipeActions: record({
        icon: element,
        key: string,
        onClick: eventListener,
        theme: oneOf(enumValues(ButtonTheme)),
    }).notEnumerable(),
    uuid: string,
    width: number,
};
CardContainer.defaultProps = {
    uuid: '',
    width: 3,
};
const awesomeProps = {
    api: CardContainerAPI,
    containers: [CardContainerContainer],
    type: ComponentType.DATA_DISPLAY,
};
AwesomeComponent(awesomeProps)(CardContainer);
export { CardContainer, };
//# sourceMappingURL=card-container.js.map